export async function handleResponse(response: Response) {
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Fehler beim Übertragen der Daten');
  }
}

// Helper-Funktion zur Fehlerbehandlung
export async function checkResponse<T>(response: Response): Promise<T> {
  await handleResponse(response);
  return response.json();
}

export async function checkResponseBoolean(response: Response): Promise<boolean> {
  await handleResponse(response);
  return true;
}
